<template>
  <div class="hcl-form-element-textarea">
    <textarea ref="fieldRef" class="hcl-form-element-textarea-textarea form-control textarea" :name="fieldName"
      :readonly="isReadOnly(props.definitionField.field)" :required="props.definitionField.field.required"
      :hidden="props.definitionField.field.hidden" type="textarea" :aria-label="fieldName"
      :value="props.dataField.value" @change="onChange" :widget="props.definitionField.field.widget?.widget"
      v-bind="generateDataAttributes" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import { useElement } from '@/components/FormElement/element'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined
})

const { fieldRef, isReadOnly, fieldName, generateDataAttributes } = useElement(props)

onMounted(() => {
  if (props.definitionField.field.focus) fieldRef.value.focus()
})

const onChange = (event: any) => {
  props.dataField.value = event?.target?.value ?? undefined
}
</script>

<style lang="scss" scoped>
.hcl-form-element-textarea {
  width: 100%;

  textarea {
    min-height: calc(1.5em + 0.75rem + 2px);
  }
}
</style>
